export const SHAPES = {
	DESTINATION_DB: 'DestinationDB',
	SOURCE_DB: 'SourceDB',
	LINK_FIELD: 'LinkField'
};